// Raportarea erorilor JavaScript neprinse (în stilul Sentry, fără serviciu extern): ajung în logul core-api,
// apoi în Loki, unde o alertă urmărește creșterile bruște. Max. 10 rapoarte per încărcare de pagină.
let sent = 0;

function report(kind: string, message: string, stack?: string) {
  if (sent >= 10) return;
  sent++;
  const body = JSON.stringify({ source: "admin", kind, message: message.slice(0, 500), stack: (stack ?? "").slice(0, 2000), url: location.pathname });
  try {
    if (!navigator.sendBeacon?.("/client-errors", new Blob([body], { type: "application/json" }))) {
      fetch("/client-errors", { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    }
  } catch {
    /* raportarea nu trebuie să strice nimic */
  }
}

export function installErrorReporting() {
  window.addEventListener("error", (e) => report("error", e.message || String(e.error), e.error?.stack));
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    report("unhandledrejection", r instanceof Error ? r.message : String(r), r instanceof Error ? r.stack : undefined);
  });
}
